import { SliderLabel } from './SliderLabel';

// TODO: in v9, move styled() from SliderLabel.jsx to here
export var StyledSliderLabel = SliderLabel;